import { useState } from "react";
import { GridSortModel } from "@mui/x-data-grid";
import Stakeholder from "@domain/model/Stakeholder";
import { LastPageState } from "@domain/model/LastPageState";
import { ILastPageService } from "@domain/services/ILastPageService";
import { ListStakeholdersPaginatedRequest, ListStakeholdersPaginatedSortDirectionEnum } from "@clients/aggrego-proxy";

export const useStakeholderPagination = (
  stakeholderData: Stakeholder[],
  currentPageService: ILastPageService,
  currentPagePersistedState: LastPageState,
  stakeholderTypeForFilters: string,
  getStakeholderPaginated: (criteria: ListStakeholdersPaginatedRequest) => Promise<void>
) => {
  const DEBOUNCE_TIME = 500;
  const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);

  const sortByFieldBackend = (model: GridSortModel) => {
    stakeholderData &&
      stakeholderData.length > 0 &&
      getStakeholderPaginated({
        limit: currentPagePersistedState.limit,
        offset: currentPagePersistedState.offset,
        status: currentPagePersistedState.status,
        customStakeholderFilter: {
          ...currentPagePersistedState.filters,
          types: [stakeholderTypeForFilters]
        },
        sortDirection: model[0]?.sort?.toUpperCase() ?? ListStakeholdersPaginatedSortDirectionEnum.Desc,
        sortField: model[0]?.field?.toUpperCase()
      } as ListStakeholdersPaginatedRequest);

    currentPageService.saveLastPageState({
      ...currentPagePersistedState,
      sortDirection: model[0]?.sort?.toUpperCase() as "ASC" | "DESC" | undefined,
      sortField: model[0]?.field?.toUpperCase()
    });
  };

  const handlePagination = (limit: number, offset: number, status?: "ALL" | "ACTIVE" | "INACTIVE", filters?: object) => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    const newDebounceTimer = setTimeout(() => {
      getStakeholderPaginated({
        status: status ?? "ALL",
        limit: limit,
        offset: offset,
        customStakeholderFilter: {
          ...filters,
          types: [stakeholderTypeForFilters]
        }
      } as ListStakeholdersPaginatedRequest);
    }, DEBOUNCE_TIME);
    setDebounceTimer(newDebounceTimer);
  };

  return {
    handlePagination,
    sortByFieldBackend
  };
};
